/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import FavoritesPage from '@bottlebooks/gatsby-theme-event/src/components/Favorites/FavoritesPage';
import { jsx } from 'theme-ui';

/**
 * We don't really need a lot of logic here because can pick up the
 * locale from the URL.
 * @param {*} param0
 * @returns
 */
export default function Favorites({ params, ...rest }) {
  return <FavoritesPage locale={params.locale} {...rest} />;
}
